// extracted by mini-css-extract-plugin
export default {"secondaryNav":"secondaryNav__SgSDr","fullWidth":"fullWidth__CrK_u"};